import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClientLabelSchema, ClientLabelWithId } from '../types/ClientLabel'

const clientLabelInitValues: ClientLabelWithId = {
	labelId: '',
	labelName: '',
	labelColor: ''
}

const initialState: ClientLabelSchema = {
	clientLabelEditable: clientLabelInitValues,
	isLoading: false,
	error: ''
}

const clientLabelSlice = createSlice({
	name: 'clientLabelSlice',
	initialState,
	reducers: {
		resetClientLabelEditable: (state) => {
			state.clientLabelEditable = clientLabelInitValues
		},
		setClientLabelEditable: (state, action: PayloadAction<ClientLabelWithId>) => {
			state.clientLabelEditable = action.payload
		},
		setLabelName: (state, action) => {
			state.clientLabelEditable.labelName = action.payload
		},
		setLabelColor: (state, action) => {
			state.clientLabelEditable.labelColor = action.payload
		},
		setIsLoading: (state, action) => {
			state.isLoading = action.payload
		}
	}
})

export const { actions: clientLabelActions } = clientLabelSlice
export const { reducer: clientLabelReducer } = clientLabelSlice
